import React from 'react';
import { I18n } from 'common/i18n';

// components
import { picklistSizingStrategy } from 'common/components/Dropdown/picklistSizingStrategy';
import { IconName, SocrataIcon } from 'common/components/SocrataIcon';
import Dropdown, { DropdownSize } from 'common/components/Forms/Dropdown';

// project constants
const scope = 'shared.visualizations.panes.data';

interface TableHierarchyGroupingKebabMenuProps {
  duplicationAllowed: boolean;
  removeAllowed: boolean;
  handleOnDuplicateHierarchy: () => void;
  handleOnRemoveHierarchy: () => void;
}

enum HierarchyMenuOption {
  DUPLICATE,
  RESET,
  REMOVE,
}

interface HierarchyMenuSelection {
  value: HierarchyMenuOption;
}

const HierarchyKebabMenu = (props: TableHierarchyGroupingKebabMenuProps) => {
  const { handleOnRemoveHierarchy, handleOnDuplicateHierarchy, removeAllowed, duplicationAllowed } = props;

  const handleSelection = (selection: HierarchyMenuSelection) => {
    switch (selection.value) {
      case HierarchyMenuOption.DUPLICATE: {
        if (duplicationAllowed) {
          handleOnDuplicateHierarchy();
        }
        break;
      }
      case HierarchyMenuOption.REMOVE: {
        handleOnRemoveHierarchy();
        break;
      }
    }

    return false;
  };

  const renderDuplicateOption = () => {
    return (
      <div role="button" data-testid="duplicate-hierarchy-button">
        <SocrataIcon name={IconName.CopyDocument} />
        <span>{I18n.t('fields.table_hierarchies.menu.duplicate', { scope })}</span>
      </div>
    );
  };

  const renderRemoveOption = () => {
    return (
      <div role="button" className="remove-hierarchy-button" data-testid="remove-hierarchy-button">
        <SocrataIcon name={IconName.Remove} />
        <span>{I18n.t('fields.table_hierarchies.menu.remove', { scope })}</span>
      </div>
    );
  };

  const renderPlaceholder = () => {
    return (
      <button
        className="dropdown-btn socrata-icon-kebab"
        aria-label={I18n.t('fields.table_hierarchies.menu.title', { scope })}
      />
    );
  };

  const options = [
    {
      render: renderDuplicateOption,
      value: HierarchyMenuOption.DUPLICATE,
      disabled: !duplicationAllowed,
    },
    {
      render: renderRemoveOption,
      value: HierarchyMenuOption.REMOVE,
      disabled: !removeAllowed,
    },
  ];

  const dropdownProps = {
    handleSelection: handleSelection,
    picklistSizingStrategy: picklistSizingStrategy.EXPAND_TO_WIDEST_ITEM,
    options,
    size: DropdownSize.SMALL,
    placeholder: renderPlaceholder,
  };

  return (
    <div className="hierarchy-actions-menu">
      <Dropdown {...dropdownProps} />
    </div>
  );
};

export default HierarchyKebabMenu;
